import firebase from "firebase";
import "firebase/firestore";
const config = {
  apiKey: "AIzaSyCTI5e_Ea3dhOQXuQGDQfSkXYzK86wJ6mk",
  authDomain: "client-data-enrichment.firebaseapp.com",
  databaseURL: "https://client-data-enrichment.firebaseio.com",
  projectId: "client-data-enrichment",
  storageBucket: "client-data-enrichment.appspot.com",
  messagingSenderId: "199460296661",
  appId: "1:199460296661:web:3638dc7313ec0b7e414f5c"
};
// Initialize Firebase
firebase.initializeApp(config);

const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

// firebase collections
const usersCollection = db.collection("users");
const clientsCollection = db.collection("clients");
const enrichLogCollection = db.collection("enrich-log");

export {
  db,
  auth,
  currentUser,
  usersCollection,
  clientsCollection,
  enrichLogCollection
};
